import {
  REQUEST_PENDING_CLAIMS,
  SET_PENDING_CLAIMS,
  REQUEST_SEARCH_PENDING_CLAIMS,
  SET_SEARCH_PENDING_CLAIMS,
} from 'containers/PendingClaimsPage/constants';

export const requestPendingClaims = (
  status: string,
  page: number,
  pageSize: number,
) => ({
  type: REQUEST_PENDING_CLAIMS,
  status,
  page,
  pageSize,
});

export const setPendingClaims = (response: any) => ({
  type: SET_PENDING_CLAIMS,
  response,
});
export const requestSearchPendingClaims = (
  searchQuery: any,
  token?: string,
) => ({
  type: REQUEST_SEARCH_PENDING_CLAIMS,
  searchQuery,
  token,
});

export const setSearchPendingClaims = (data: any) => ({
  type: SET_SEARCH_PENDING_CLAIMS,
  data,
});
